import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import OnboardingForm from '@/components/OnboardingForm';

const Onboarding = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  useEffect(() => {
    // Redirect to login if no user data
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleComplete = (updatedUser) => {
    // If user originally tried to access a product before logging in, send them
    // through the surprise interstitial instead of straight to the discovery page.
    const hasPendingProduct = !!sessionStorage.getItem('pendingProduct');
    if (hasPendingProduct) {
      navigate('/welcome', { state: { user: updatedUser }, replace: true });
      return;
    }
    // Navigate to discovery with updated user data
    navigate('/', { state: { user: updatedUser }, replace: true });
  };

  if (!user) return null;

  return (
    <div className="min-h-screen flex items-center justify-center">
      <OnboardingForm onComplete={handleComplete} />
    </div>
  );
};

export default Onboarding;